import {
  CHANGE_PASSWORD,
  FETCH_COUNTRIES,
  FETCH_EMPLOYMENT_DETAILS,
  FETCH_FINANCIAL_DETAILS,
  FETCH_INDUSTRIES,
  FETCH_PERSONAL_DETAILS,
  LOGOUT,
  REFRESH_TOKEN,
  SIGN_IN,
  SIGNUP,
  SUBMIT_EMPLOYMENT_DETAILS,
  SUBMIT_FINANCIAL_DETAILS,
  SUBMIT_PERSONAL_DETAILS,
  SUBMIT_DOCUMENTS,
  UPDATE_EMPLOYMENT_DETAILS,
  UPDATE_FINANCIAL_DETAILS,
  UPDATE_PERSONAL_DETAILS,
  FETCH_ONBOARDING_STATUS,
  ONBOARDING_VALIDATE,
  ONBOARDING_REGISTER,
  FETCH_TRADING_EXPERIENCE,
  SUBMIT_TRADING_EXPERIENCE,
  UPDATE_TRADING_EXPERIENCE,
  SUBMIT_TRADING_ACCOUNTS,
  FETCH_TRADING_ACCOUNTS,
  SEND_OTP,
  VERIFY_OTP,
  FETCH_USER,
  SOCIAL_SIGN_IN,
  SET_SIGNUP_DETAILS,
  SOCIAL_SIGNUP,
  EMAIL_VERIFICATION,
  PHONE_VERIFICATION,
  FETCH_ACCOUNT_TYPES,
  FETCH_PLATFORM_SERVERS,
  INITIATE_FORGOT_PASSWORD,
  FORGOT_PASSWORD_RESET,
  UPDATE_LEVERAGE,
  INITIATE_RESET_PASSWORD,
  RESET_PASSWORD,
  FETCH_INTRODUCING_BROKER_APPLICATION,
  SUBMIT_INTRODUCING_BROKER_APPLICATION,
  FETCH_REFERRAL_LINKS,
  SUBMIT_REFERRAL_LINK,
  FETCH_NEWS,
  FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION,
  FETCH_CLIENT_CABINET_CLIENT_COMMISSION,
  FETCH_CLIENT_CABINET_IB_COMMISSIONS,
  FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD,
  FETCH_CLIENT_CABINET_IB_REFERRALS,
  FETCH_CLIENT_CABINET_IB_TRANSACTIONS,
  FETCH_CLIENT_CABINET_COMMISSION_SETTINGS,
  MONITORING_CLIENTS,
  MONITORING_META_CLIENTS,
  TRANSFERS,
  FETCH_SOCIAL_TRADING_PROVIDERS,
  FETCH_SOCIAL_TRADING_PROVIDER_OFFERS,
  SUBSCRIBE_TO_SOCIAL_TRADING_PROVIDER,
  SUBMIT_SOCIAL_TRADING_PROVIDER,
  SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER,
  FETCH_SOCIAL_TRADING_PROVIDER_CONFIG,
  FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS,
  FETCH_SOCIAL_TRADING_PROVIDER_DETAILS,
  FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART,
  FETCH_SOCIAL_TRADING_PROVIDER_METRICS,
  FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS,
  FETCH_SOCIAL_TRADING_PROVIDER_DEALS,
  UPDATE_SOCIAL_TRADING_PROVIDER,
  FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO,
  UPDATE_SOCIAL_TRADING_SUBSCRIPTION,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS,
  FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK,
  UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK,
  DELETE_SOCIAL_TRADING_SUBSCRIPTION,
  FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO,
  FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS,
  FETCH_SOCIAL_TRADING_OFFER_DETAILS,
  FETCH_SOCIAL_TRADING_FEES,
  SUBMIT_PROVIDER_APPLICATION,
  FETCH_SOCIAL_TRADING_RATE_PROFILE,
  FETCH_SOCIAL_TRADING_HISTORY_INDICATORS,
  FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT,
  FETCH_SOCIAL_TRADING_TRADE_REPORT,
  FETCH_CONTACTS,
  SUBMIT_CONTACT,
  FETCH_SWAP_FREE_DETAILS,
  SUBMIT_SWAP_FREE,
  HYDRATE_USER,
} from "_constants";
import { getClearActionType, reduxRequest, getUserFromAccessToken, getAccessToken } from "_helpers";
import { customerManagementService, socialTradingService } from "_services";

export const signup = (user) => {
  return (dispatch) =>
    reduxRequest(dispatch, SIGNUP, customerManagementService.signup(user));
};

export const clearSignupStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(SIGNUP) });
};

export const signIn = (user, options = {}) => {
  return (dispatch) =>
    reduxRequest(dispatch, SIGN_IN, customerManagementService.signIn(user), {
      successDispatchData: options,
    });
};

export const clearSignInStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(SIGN_IN) });
};

export const changePassword = (changePasswordData) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      CHANGE_PASSWORD,
      customerManagementService.changePassword(changePasswordData)
    );
};

export const clearChangePasswordStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(CHANGE_PASSWORD) });
};

export const refreshToken = (refreshTokenData) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      REFRESH_TOKEN,
      customerManagementService.refreshToken(refreshTokenData)
    );
};

export const logout = () => {
  return (dispatch) =>
    reduxRequest(dispatch, LOGOUT, customerManagementService.logout());
};

export const submitDocuments = (proofOfIdentityDocuments) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_DOCUMENTS,
      customerManagementService.submitDocuments(proofOfIdentityDocuments),
      { isAllRequest: true }
    );
};

export const clearSubmitDocumentsStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(SUBMIT_DOCUMENTS) });
};

export const submitEmploymentDetails = (employmentDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_EMPLOYMENT_DETAILS,
      customerManagementService.submitEmploymentDetails(employmentDetails)
    );
};

export const clearSubmitEmploymentDetailsStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(SUBMIT_EMPLOYMENT_DETAILS) });
};

export const updateEmploymentDetails = (employmentDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      UPDATE_EMPLOYMENT_DETAILS,
      customerManagementService.updateEmploymentDetails(employmentDetails)
    );
};

export const clearUpdateEmploymentDetailsStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(UPDATE_EMPLOYMENT_DETAILS) });
};

export const fetchEmploymentDetails = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_EMPLOYMENT_DETAILS,
      customerManagementService.fetchEmploymentDetails()
    );
};

export const clearEmploymentDetailsStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_EMPLOYMENT_DETAILS) });
};

export const fetchFinancialDetails = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_FINANCIAL_DETAILS,
      customerManagementService.fetchFinancialDetails()
    );
};

export const clearFinancialDetailsStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_FINANCIAL_DETAILS) });
};

export const submitFinancialDetails = (financialDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_FINANCIAL_DETAILS,
      customerManagementService.submitFinancialDetails(financialDetails)
    );
};

export const clearSubmitFinancialDetailsStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(SUBMIT_FINANCIAL_DETAILS) });
};

export const updateFinancialDetails = (financialDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      UPDATE_FINANCIAL_DETAILS,
      customerManagementService.updateFinancialDetails(financialDetails)
    );
};

export const clearUpdateFinancialDetailsStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(UPDATE_FINANCIAL_DETAILS) });
};

export const fetchPersonalDetails = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_PERSONAL_DETAILS,
      customerManagementService.fetchPersonalDetails()
    );
};

export const clearPersonalDetailsStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_PERSONAL_DETAILS) });
};

export const submitPersonalDetails = (personalDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_PERSONAL_DETAILS,
      customerManagementService.submitPersonalDetails(personalDetails)
    );
};

export const clearSubmitPersonalDetailsStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(SUBMIT_PERSONAL_DETAILS) });
};

export const updatePersonalDetails = (personalDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      UPDATE_PERSONAL_DETAILS,
      customerManagementService.updatePersonalDetails(personalDetails)
    );
};

export const clearUpdatePersonalDetailsStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(UPDATE_PERSONAL_DETAILS) });
};

export const fetchCountries = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_COUNTRIES,
      customerManagementService.fetchCountries()
    );
};

export const fetchIndustries = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_INDUSTRIES,
      customerManagementService.fetchIndustries()
    );
};

export const fetchOnboardingStatus = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_ONBOARDING_STATUS,
      customerManagementService.fetchOnboardingStatus()
    );
};

export const clearOnboardingStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_ONBOARDING_STATUS) });
};

export const onboardingValidate = (onboardingDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      ONBOARDING_VALIDATE,
      customerManagementService.onboardingValidate(onboardingDetails)
    );
};

export const clearOnboardingValidateStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(ONBOARDING_VALIDATE) });
};

export const onboardingRegister = (registerDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      ONBOARDING_REGISTER,
      customerManagementService.onboardingRegister(registerDetails)
    );
};

export const clearOnboardingRegisterStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(ONBOARDING_REGISTER) });
};

export const fetchTradingExperience = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_TRADING_EXPERIENCE,
      customerManagementService.fetchTradingExperience()
    );
};

export const clearTradingExperienceStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_TRADING_EXPERIENCE) });
};

export const submitTradingExperience = (tradingExperienceDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_TRADING_EXPERIENCE,
      customerManagementService.submitTradingExperience(tradingExperienceDetails)
    );
};

export const clearSubmitTradingExperienceStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(SUBMIT_TRADING_EXPERIENCE) });
};

export const updateTradingExperience = (tradingExperienceDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      UPDATE_TRADING_EXPERIENCE,
      customerManagementService.updateTradingExperience(tradingExperienceDetails)
    );
};

export const clearUpdateTradingExperienceStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(UPDATE_TRADING_EXPERIENCE) });
};

export const submitTradingAccounts = (tradingAccounts, scope) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_TRADING_ACCOUNTS,
      customerManagementService.submitTradingAccounts(tradingAccounts, scope)
    );
};

export const clearSubmitTradingAccountsStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(SUBMIT_TRADING_ACCOUNTS) });
};

export const fetchTradingAccounts = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_TRADING_ACCOUNTS,
      customerManagementService.fetchTradingAccounts()
    );
};

export const clearTradingAccountsStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_TRADING_ACCOUNTS) });
};

export const sendOTP = (sendOTPDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SEND_OTP,
      customerManagementService.sendOTP(sendOTPDetails)
    );
};

export const clearSendOTPStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(SEND_OTP) });
};

export const verifyOTP = (verifyOTPDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      VERIFY_OTP,
      customerManagementService.verifyOTP(verifyOTPDetails),
      { successDispatchData: { ...verifyOTPDetails } }
    );
};

export const clearVerifyOTPStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(VERIFY_OTP) });
};

export const fetchUser = () => {
  return (dispatch) =>
    reduxRequest(dispatch, FETCH_USER, customerManagementService.fetchUser());
};

export const clearUserStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(FETCH_USER) });
};

export const socialSignIn = (socialSignInDetails) => {
  const { isSignup, ...payload } = socialSignInDetails;
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SOCIAL_SIGN_IN,
      customerManagementService.socialSignIn(payload)
    );
};

export const clearSocialSignInStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(SOCIAL_SIGN_IN) });
};

export const socialSignup = (socialSignupDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SOCIAL_SIGNUP,
      customerManagementService.socialSignup(socialSignupDetails),
      {
        successDispatchData: {
          ...(socialSignupDetails || {}),
          isSignup: false,
        },
      }
    );
};

export const clearSocialSignupStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(SOCIAL_SIGNUP) });
};

export const setSignupDetails = (payload) => {
  return (dispatch) => dispatch({ type: SET_SIGNUP_DETAILS, payload });
};

export const emailVerification = (emailVerificationDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      EMAIL_VERIFICATION,
      customerManagementService.emailVerification(emailVerificationDetails)
    );
};

export const clearEmailVerificationStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(EMAIL_VERIFICATION) });
};

export const phoneVerification = (phoneVerificationDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      PHONE_VERIFICATION,
      customerManagementService.phoneVerification(phoneVerificationDetails)
    );
};

export const clearPhoneVerificationStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(PHONE_VERIFICATION) });
};

export const fetchAccountTypes = (params) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_ACCOUNT_TYPES,
      customerManagementService.fetchAccountTypes(params)
    );
};

export const clearAccountTypesStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_ACCOUNT_TYPES) });
};

export const fetchPlatformServers = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_PLATFORM_SERVERS,
      customerManagementService.fetchPlatformServers()
    );
};

export const clearPlatformServersStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_PLATFORM_SERVERS) });
};

export const initiateForgotPassword = (initiateForgotPasswordDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      INITIATE_FORGOT_PASSWORD,
      customerManagementService.initiateForgotPassword(
        initiateForgotPasswordDetails
      )
    );
};

export const clearInitiateForgotPasswordStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(INITIATE_FORGOT_PASSWORD) });
};

export const forgotPasswordReset = (forgotPasswordResetDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FORGOT_PASSWORD_RESET,
      customerManagementService.forgotPasswordReset(forgotPasswordResetDetails)
    );
};

export const clearForgotPasswordResetStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FORGOT_PASSWORD_RESET) });
};

export const updateLeverage = (updateLeverageDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      UPDATE_LEVERAGE,
      customerManagementService.updateLeverage(updateLeverageDetails)
    );
};

export const clearUpdateLeverageStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(UPDATE_LEVERAGE) });
};

export const initiateResetPassword = (initiateResetPasswordDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      INITIATE_RESET_PASSWORD,
      customerManagementService.initiateResetPassword(
        initiateResetPasswordDetails
      )
    );
};

export const clearInitiateResetPasswordStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(INITIATE_RESET_PASSWORD) });
};

export const resetPassword = (resetPasswordDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      RESET_PASSWORD,
      customerManagementService.resetPassword(resetPasswordDetails)
    );
};

export const clearResetPasswordStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(RESET_PASSWORD) });
};

export const fetchSocialTradingProviders = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_PROVIDERS,
      socialTradingService.fetchSocialTradingProviders()
    );
};

export const clearSocialTradingProvidersStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_SOCIAL_TRADING_PROVIDERS) });
};

export const fetchSocialTradingProviderOffers = (
  socialTradingProviderDetails
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_PROVIDER_OFFERS,
      socialTradingService.fetchSocialTradingProviderOffers(
        socialTradingProviderDetails
      )
    );
};

export const clearSocialTradingProviderOffersStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_OFFERS),
    });
};

export const subscribeToSocialTradingProvider = (
  socialTradingProviderSubscriptionDetails
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBSCRIBE_TO_SOCIAL_TRADING_PROVIDER,
      socialTradingService.subscribeAggregate(
        socialTradingProviderSubscriptionDetails
      )
    );
};

export const clearSubscribeToSocialTradingProviderStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(SUBSCRIBE_TO_SOCIAL_TRADING_PROVIDER),
    });
};

export const transfers = (transfersDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      TRANSFERS,
      customerManagementService.transfers(transfersDetails)
    );
};

export const clearTransfersStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(TRANSFERS) });
};

export const fetchIntroducingBrokerApplication = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_INTRODUCING_BROKER_APPLICATION,
      customerManagementService.fetchIntroducingBrokerApplication()
    );
};

export const clearIntroducingBrokerApplicationStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_INTRODUCING_BROKER_APPLICATION),
    });
};

export const submitIntroducingBrokerApplication = (
  introducingBrokerApplicationDetails
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_INTRODUCING_BROKER_APPLICATION,
      customerManagementService.submitIntroducingBrokerApplication(
        introducingBrokerApplicationDetails
      )
    );
};

export const clearSubmitIntroducingBrokerApplicationStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(SUBMIT_INTRODUCING_BROKER_APPLICATION),
    });
};

export const fetchReferralLinks = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_REFERRAL_LINKS,
      customerManagementService.fetchReferralLinks()
    );
};

export const clearReferralLinksStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(FETCH_REFERRAL_LINKS) });
};

export const submitReferralLink = (referralLinkDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_REFERRAL_LINK,
      customerManagementService.submitReferralLink(referralLinkDetails)
    );
};

export const clearSubmitReferralLinkStatus = () => {
  return (dispatch) =>
    dispatch({ type: getClearActionType(SUBMIT_REFERRAL_LINK) });
};

export const fetchNews = (newsParams) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_NEWS,
      customerManagementService.fetchNews(newsParams)
    );
};

export const clearNewsStatus = () => {
  return (dispatch) => dispatch({ type: getClearActionType(FETCH_NEWS) });
};

export const fetchClientCabinetAccountCommission = (
  accountCommissionParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION,
      customerManagementService.fetchClientCabinetAccountCommission(
        accountCommissionParams
      )
    );
};

export const clearClientCabinetAccountCommissionStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_CLIENT_CABINET_ACCOUNT_COMMISSION),
    });
};

export const fetchClientCabinetClientCommission = (clientCommissionParams) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_CLIENT_CABINET_CLIENT_COMMISSION,
      customerManagementService.fetchClientCabinetClientCommission(
        clientCommissionParams
      )
    );
};

export const clearClientCabinetClientCommissionStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_CLIENT_CABINET_CLIENT_COMMISSION),
    });
};

export const fetchClientCabinetCommissionSettings = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_CLIENT_CABINET_COMMISSION_SETTINGS,
      customerManagementService.fetchClientCabinetCommissionSettings()
    );
};

export const clearClientCabinetCommissionSettingsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_CLIENT_CABINET_COMMISSION_SETTINGS),
    });
};

export const fetchClientCabinetIBCommissions = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_CLIENT_CABINET_IB_COMMISSIONS,
      customerManagementService.fetchClientCabinetIBCommissions()
    );
};

export const clearClientCabinetIBCommissionsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_CLIENT_CABINET_IB_COMMISSIONS),
    });
};

export const fetchClientCabinetIBPerformanceDashboard = (
  ibPerformanceDashboardParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD,
      customerManagementService.fetchClientCabinetIBPerformanceDashboard(
        ibPerformanceDashboardParams
      )
    );
};

export const clearClientCabinetIBPerformanceDashboardStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_CLIENT_CABINET_IB_PERFORMANCE_DASHBOARD),
    });
};

export const fetchClientCabinetIBReferrals = (ibReferralsParams) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_CLIENT_CABINET_IB_REFERRALS,
      customerManagementService.fetchClientCabinetIBReferrals(ibReferralsParams)
    );
};

export const clearClientCabinetIBReferralsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_CLIENT_CABINET_IB_REFERRALS),
    });
};

export const fetchClientCabinetIBTransactions = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_CLIENT_CABINET_IB_TRANSACTIONS,
      customerManagementService.fetchClientCabinetIBTransactions()
    );
};

export const clearClientCabinetIBTransactionsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_CLIENT_CABINET_IB_TRANSACTIONS),
    });
};

export const monitorClients = (monitorClientsParams) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      MONITORING_CLIENTS,
      customerManagementService.monitorClients(monitorClientsParams)
    );
};

export const clearMonitorClientsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(MONITORING_CLIENTS),
    });
};

export const monitorMetaClients = (monitorMetaClientsParams) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      MONITORING_META_CLIENTS,
      customerManagementService.monitorMetaClients(monitorMetaClientsParams)
    );
};

export const clearMonitorMetaClientsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(MONITORING_META_CLIENTS),
    });
};

export const submitSocialTradingProvider = (
  submitSocialTradingProviderDetails
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_SOCIAL_TRADING_PROVIDER,
      socialTradingService.submitSocialTradingProvider(
        submitSocialTradingProviderDetails
      )
    );
};

export const clearSubmitSocialTradingProviderStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(SUBMIT_SOCIAL_TRADING_PROVIDER),
    });
};

export const submitSocialTradingProviderOffer = (
  submitSocialTradingProviderOfferDetails
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER,
      socialTradingService.submitSocialTradingProviderOffer(
        submitSocialTradingProviderOfferDetails
      )
    );
};

export const clearSubmitSocialTradingProviderOfferStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(SUBMIT_SOCIAL_TRADING_PROVIDER_OFFER),
    });
};

export const fetchSocialTradingProvidersConfig = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_PROVIDER_CONFIG,
      socialTradingService.fetchSocialTradingProvidersConfig()
    );
};

export const clearSocialTradingProviderConfigStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_CONFIG),
    });
};

export const fetchSocialTradingProviderPositions = (
  socialTradingProviderPositionsDetails
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS,
      socialTradingService.fetchSocialTradingProviderPositions(
        socialTradingProviderPositionsDetails
      )
    );
};

export const clearSocialTradingProviderPositions = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_POSITIONS),
    });
};

export const fetchSocialTradingProviderDetails = (
  socialTradingProviderDetails
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_PROVIDER_DETAILS,
      socialTradingService.fetchSocialTradingProviderDetails(
        socialTradingProviderDetails
      )
    );
};

export const clearSocialTradingProviderDetailsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_DETAILS),
    });
};

export const fetchSocialTradingHistoryDailyChart = (
  socialTradingHistoryChartDetails
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART,
      socialTradingService.fetchSocialTradingHistoryDailyChart(
        socialTradingHistoryChartDetails
      )
    );
};

export const clearSocialTradingHistoryChartStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_HISTORY_DAILY_CHART),
    });
};

export const fetchSocialTradingProviderMetrics = (
  socialTradingProviderMetricsParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_PROVIDER_METRICS,
      socialTradingService.fetchSocialTradingProviderMetrics(
        socialTradingProviderMetricsParams
      )
    );
};

export const clearSocialTradingProviderMetricsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_METRICS),
    });
};

export const fetchSocialTradingProviderSubscriptions = (
  socialTradingProviderSubscriptionsParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS,
      socialTradingService.fetchSocialTradingProviderSubscriptions(
        socialTradingProviderSubscriptionsParams
      )
    );
};

export const clearSocialTradingProviderSubscriptionsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_SUBSCRIPTIONS),
    });
};

export const fetchSocialTradingProviderDeals = (
  socialTradingProviderDealsParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_PROVIDER_DEALS,
      socialTradingService.fetchSocialTradingProviderDeals(
        socialTradingProviderDealsParams
      )
    );
};

export const clearSocialTradingProviderDealsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_DEALS),
    });
};

export const updateSocialTradingProvider = (
  updateSocialTradingProviderDetails
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      UPDATE_SOCIAL_TRADING_PROVIDER,
      socialTradingService.updateSocialTradingProvider(
        updateSocialTradingProviderDetails
      )
    );
};

export const clearUpdateSocialTradingProviderStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(UPDATE_SOCIAL_TRADING_PROVIDER),
    });
};

export const fetchSocialTradingProviderPortfolio = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO,
      socialTradingService.fetchSocialTradingProviderPortfolio()
    );
};

export const clearSocialTradingProviderPortfolioStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_PROVIDER_PORTFOLIO),
    });
};

export const updateSocialTradingSubscription = (
  updateSocialTradingSubscriptionDetails
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      UPDATE_SOCIAL_TRADING_SUBSCRIPTION,
      socialTradingService.updateSocialTradingSubscription(
        updateSocialTradingSubscriptionDetails
      )
    );
};

export const clearUpdateSocialTradingSubscriptionStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(UPDATE_SOCIAL_TRADING_SUBSCRIPTION),
    });
};

export const fetchSocialTradingSubscriptionDetails = (
  socialTradingSubscriptionParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS,
      socialTradingService.fetchSocialTradingSubscriptionDetails(
        socialTradingSubscriptionParams
      )
    );
};

export const clearSocialTradingSubscriptionDetailsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_DETAILS),
    });
};

export const fetchSocialTradingSubscriptionDeals = (
  socialTradingSubscriptionDealsParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS,
      socialTradingService.fetchSocialTradingSubscriptionDeals(
        socialTradingSubscriptionDealsParams
      )
    );
};

export const clearSocialTradingSubscriptionDealsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_DEALS),
    });
};

export const fetchSocialTradingSubscriptionMetrics = (
  socialTradingSubscriptionMetricsParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS,
      socialTradingService.fetchSocialTradingSubscriptionMetrics(
        socialTradingSubscriptionMetricsParams
      )
    );
};

export const clearSocialTradingSubscriptionMetricsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_METRICS),
    });
};

export const fetchSocialTradingSubscriptionTradingResults = (
  socialTradingSubscriptionTradingResultsParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS,
      socialTradingService.fetchSocialTradingSubscriptionTradingResults(
        socialTradingSubscriptionTradingResultsParams
      )
    );
};

export const clearSocialTradingSubscriptionTradingResultsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(
        FETCH_SOCIAL_TRADING_SUBSCRIPTION_TRADING_RESULTS
      ),
    });
};

export const fetchSocialTradingSubscriptionRisk = (
  socialTradingSubscriptionRiskParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK,
      socialTradingService.fetchSocialTradingSubscriptionRisk(
        socialTradingSubscriptionRiskParams
      )
    );
};

export const clearSocialTradingSubscriptionRiskStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_SUBSCRIPTION_RISK),
    });
};

export const updateSocialTradingSubscriptionRisk = (
  updateSocialTradingSubscriptionRiskDetails
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK,
      socialTradingService.updateSocialTradingSubscriptionRisk(
        updateSocialTradingSubscriptionRiskDetails
      )
    );
};

export const clearUpdateSocialTradingSubscriptionRiskStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(UPDATE_SOCIAL_TRADING_SUBSCRIPTION_RISK),
    });
};

export const deleteSocialTradingSubscription = (
  socialTradingSubscriptionDetails
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      DELETE_SOCIAL_TRADING_SUBSCRIPTION,
      socialTradingService.deleteSocialTradingSubscription(
        socialTradingSubscriptionDetails
      )
    );
};

export const clearDeleteSocialTradingSubscriptionStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(DELETE_SOCIAL_TRADING_SUBSCRIPTION),
    });
};

export const fetchSocialTradingFollowerPortfolio = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO,
      socialTradingService.fetchSocialTradingFollowerPortfolio()
    );
};

export const clearSocialTradingFollowerPortfolioStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_FOLLOWER_PORTFOLIO),
    });
};

export const fetchSocialTradingFollowerPositions = (
  socialTradingFollowerPositionsParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS,
      socialTradingService.fetchSocialTradingFollowerPositions(
        socialTradingFollowerPositionsParams
      )
    );
};

export const clearSocialTradingFollowerPositionsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_FOLLOWER_POSITIONS),
    });
};

export const fetchSocialTradingOfferDetails = (
  socialTradingOfferDetailsParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_OFFER_DETAILS,
      socialTradingService.fetchSocialTradingOfferDetails(
        socialTradingOfferDetailsParams
      )
    );
};

export const clearSocialTradingOfferDetailsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_OFFER_DETAILS),
    });
};

export const fetchSocialTradingFees = (socialTradingFeesParams) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_FEES,
      socialTradingService.fetchSocialTradingFees(socialTradingFeesParams)
    );
};

export const clearSocialTradingFeesStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_FEES),
    });
};

export const submitProviderApplication = (applicationDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_PROVIDER_APPLICATION,
      socialTradingService.submitProviderApplication(applicationDetails)
    );
};

export const clearSubmitProviderApplicationStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(SUBMIT_PROVIDER_APPLICATION),
    });
};

export const fetchSocialTradingRateProfile = (
  socialTradingRateProfileParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_RATE_PROFILE,
      socialTradingService.fetchSocialTradingRateProfile(
        socialTradingRateProfileParams
      )
    );
};

export const clearSocialTradingRateProfileStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_RATE_PROFILE),
    });
};

export const fetchSocialTradingHistoryIndicators = (
  socialTradingHistoryIndicatorsParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_HISTORY_INDICATORS,
      socialTradingService.fetchSocialTradingHistoryIndicators(
        socialTradingHistoryIndicatorsParams
      )
    );
};

export const clearSocialTradingHistoryIndicatorsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_HISTORY_INDICATORS),
    });
};

export const fetchSocialTradingInstrumentReport = (
  socialTradingInstrumentReportParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT,
      socialTradingService.fetchSocialTradingInstrumentReport(
        socialTradingInstrumentReportParams
      )
    );
};

export const clearSocialTradingInstrumentReportStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_INSTRUMENT_REPORT),
    });
};

export const fetchSocialTradingTradeReport = (
  socialTradingTradeReportParams
) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SOCIAL_TRADING_TRADE_REPORT,
      socialTradingService.fetchSocialTradingTradeReport(
        socialTradingTradeReportParams
      )
    );
};

export const clearSocialTradingTradeReportStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SOCIAL_TRADING_TRADE_REPORT),
    });
};

export const fetchContacts = () => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_CONTACTS,
      customerManagementService.fetchContacts()
    );
};

export const clearContactsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_CONTACTS),
    });
};

export const submitContact = (submitContactDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_CONTACT,
      customerManagementService.submitContact(submitContactDetails)
    );
};

export const clearSubmitContactStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(SUBMIT_CONTACT),
    });
};

export const fetchSwapFreeDetails = (params) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      FETCH_SWAP_FREE_DETAILS,
      customerManagementService.fetchSwapFreeDetails(params)
    );
};

export const clearSwapFreeDetailsStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(FETCH_SWAP_FREE_DETAILS),
    });
};


export const submitSwapFree = (submitSwapFreeDetails) => {
  return (dispatch) =>
    reduxRequest(
      dispatch,
      SUBMIT_SWAP_FREE,
      customerManagementService.submitSwapFree(submitSwapFreeDetails)
    );
};

export const clearSubmitSwapFreeStatus = () => {
  return (dispatch) =>
    dispatch({
      type: getClearActionType(SUBMIT_SWAP_FREE),
    });
};

export const hydrateUserFromToken = () => {
  return (dispatch) => {
    const user = getUserFromAccessToken(getAccessToken());
    if (user) {
      dispatch({ type: HYDRATE_USER, payload: user });
    }
  };
};




